import React from "react";
import img from "Common/img/BCI Logo.png";
import nextId from "react-id-generator";
import { setPrefix } from "react-id-generator";

export default class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI.
    return { error: error };
  }

  componentDidCatch(error, info) {
    // Log the error to an error reporting service
    console.log(error.toString(), info.componentStack);
    return { error: error };
  }

  handleClick() {
    console.log("errorPage");
    window.location.reload(true);
  }

  render() {
    console.log("this.state.error" + this.state.error);
    if (this.state.error) {
      return (
        <div className="ErrorMessage01">
          <table width="990px" align="center">
            <tbody>
              <tr>
                <td>
                  Please call your local IT Support number or raise remedy
                  ticket and assign to PROService team, to report the below
                  error Error Code: 1973637
                </td>
              </tr>

              <tr>
                <td>
                  {" "}
                  {
                    <a id={nextId()} href="" onClick={this.handleClick}>
                      [refresh]
                    </a>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
    return this.props.children;
  }
}
